import React from 'react';
import './Toast.css';

const ICONS = {
  success: '✓',
  error: '✕',
  info: 'ℹ',
  warning: '⚠',
};

export default function Toast({ message, type = 'info', onDismiss }) {
  return (
    <div
      className={`toast toast-${type}`}
      role="status"
      onClick={onDismiss}
    >
      <span className="toast-icon" aria-hidden="true">{ICONS[type] || ICONS.info}</span>
      <span className="toast-message">{message}</span>
    </div>
  );
}
